import { IonRefresher, IonRefresherContent } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { AlertPresenter } from '../../app/AlertBinder.tsx';

export interface RefresherEventDetail {
    complete(): void;
}

export type RefresherEvent = CustomEvent<RefresherEventDetail>;

export interface RefresherProps {
    onRefresh: () => Promise<void> | void;
}

export const Refresher: React.FC<RefresherProps> = ({ onRefresh }) => {
    const alert = useInstance(AlertPresenter);

    const handleRefresh = async (event: RefresherEvent) => {
        try{
            await onRefresh();
        } catch (err){
            alert.showAndLogError(err);
        } finally {
            event.detail.complete();
        }
    };

    return (
        <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
            <IonRefresherContent />
        </IonRefresher>
    );
};
